// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"36c12746","453":"45653d8f","509":"0fd5e231"}[chunkId] + ".chunk.js";
};